/*
 * Order Now buttons (snippets/as-order-now.liquid): skip the cart and go straight to checkout.
 *
 * Razorpay Magic Checkout treats a click on .rzp-magic-btn__buy-product as "buy now": it empties
 * the cart, adds the item through window.customMagicAddToCart when that is set, then opens its
 * checkout. Left alone, Magic takes the item from ?variant= in the page URL ahead of the clicked
 * button, so a product card on a product page would buy the page's product instead. This listener
 * runs first (window capture, before Magic's document capture listener) and sets that hook to add
 * exactly the button's variant and quantity, then lets Magic take the click.
 *
 * If Magic isn't live, or its script hasn't loaded, the item is added here and the shopper is sent
 * to Shopify checkout.
 */
(function () {
  if (window.asOrderNow) return;
  window.asOrderNow = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var busyUntil = 0;
  var hookArmed = false;
  var hookTimer = null;
  var previousHook;

  function magicCheckoutLive() {
    var el = document.getElementById('RazorpayMagicCheckoutConfig');
    if (!el) return false;
    try {
      var config = JSON.parse(el.textContent).config || {};
      return Boolean(config.merchant_key) && (config.productConfig || {}).status === 'live';
    } catch (error) {
      return false;
    }
  }

  // The variant and quantity to buy, or null when the selected variant can't be bought.
  function itemFor(button) {
    var item = { id: Number(button.getAttribute('data-variant-id')), quantity: 1 };
    var form = button.closest('form[action*="/cart/add"]');

    if (form) {
      // The theme disables Add to Cart for sold-out variants.
      var addButton = form.querySelector('[name="add"]');
      var select = form.querySelector('select[name="id"]');
      var option = select && select.options[select.selectedIndex];
      if ((addButton && addButton.disabled) || (option && option.disabled)) return null;

      // What submitting this form would send. When a name repeats, Shopify uses the last value.
      var data = new FormData(form);
      var ids = data.getAll('id');
      var quantities = data.getAll('quantity');
      if (ids.length) item.id = Number(ids[ids.length - 1]);
      if (quantities.length) item.quantity = parseInt(quantities[quantities.length - 1], 10) || 1;
      data.forEach(function (value, key) {
        var property = /^properties\[(.+)\]$/.exec(key);
        if (property && typeof value === 'string' && value !== '') {
          item.properties = item.properties || {};
          item.properties[property[1]] = value;
        }
      });
      if (data.get('selling_plan')) item.selling_plan = data.get('selling_plan');
    }

    return item.id > 0 ? item : null;
  }

  function addToCart(item) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [item] })
    }).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (cart) {
        if (!response.ok) throw new Error(cart.description || 'Sorry, this product could not be added. Please try again.');
        return cart;
      });
    });
  }

  // Magic calls the hook once per buy-now click, after it has emptied the cart.
  function armMagicHook(item) {
    disarmMagicHook();
    previousHook = window.customMagicAddToCart;
    hookArmed = true;
    window.customMagicAddToCart = function () {
      disarmMagicHook();
      return addToCart(item).finally(function () {
        busyUntil = Date.now() + 1500;
      });
    };
    // In case Magic stops before asking for the item.
    hookTimer = setTimeout(disarmMagicHook, 30000);
  }

  function disarmMagicHook() {
    clearTimeout(hookTimer);
    if (!hookArmed) return;
    hookArmed = false;
    window.customMagicAddToCart = previousHook;
  }

  function checkoutWithoutMagic(button, item) {
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    addToCart(item).then(function () {
      window.location.href = root + 'checkout';
    }).catch(function (error) {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      window.alert(error.message);
    });
  }

  window.addEventListener('click', function (event) {
    var target = event.target.nodeType === 1 ? event.target : event.target.parentElement;
    var button = target && target.closest('[data-as-order-now]');
    if (!button) return;

    var item = itemFor(button);
    var busy = Date.now() < busyUntil;
    if (!item || busy || !magicCheckoutLive()) {
      // Keep Magic from starting its own buy-now for this click.
      event.preventDefault();
      event.stopImmediatePropagation();
      if (item && !busy) checkoutWithoutMagic(button, item);
      return;
    }

    busyUntil = Date.now() + 5000;
    armMagicHook(item);

    // Magic cancels the click when it takes it. If nothing did, its script isn't running.
    setTimeout(function () {
      if (event.defaultPrevented) return;
      disarmMagicHook();
      busyUntil = 0;
      checkoutWithoutMagic(button, item);
    }, 0);
  }, true);

  // Coming back from checkout with the browser's Back button restores the page as it was left.
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    busyUntil = 0;
    var buttons = document.querySelectorAll('[data-as-order-now][aria-busy]');
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].disabled = false;
      buttons[i].removeAttribute('aria-busy');
    }
  });
})();
